export default __webpack_public_path__ + "static/media/after.1e312e4f.png";